// extracted by mini-css-extract-plugin
export default {"tutorialBG":"TutorialStyles_tutorialBG__qStk7","show":"TutorialStyles_show__rJzJp","tutorial":"TutorialStyles_tutorial__RTSwE","skipCount":"TutorialStyles_skipCount__hpODr"};